import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "../loading";
import { postCall } from "../../utils/api";

const initialState = {
  data: [],
  error: "",
  status: "idle",
};

export const addNotification = createAsyncThunk(
  "notification/add",
  async (data, { dispatch }) => {
    dispatch(startLoading());
    try {
      const response = await postCall("/admin/v1/add_notification", data);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    } finally {
      dispatch(stopLoading());
    }
  }
);

const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addNotification.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.data.push(action.payload);
    });
  },
});

export default NotificationSlice.reducer;
